import { render, staticRenderFns } from "./NewTask.vue?vue&type=template&id=b429efb8&scoped=true&"
import script from "./NewTask.vue?vue&type=script&lang=js&"
export * from "./NewTask.vue?vue&type=script&lang=js&"
import style0 from "./NewTask.vue?vue&type=style&index=0&id=b429efb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b429efb8",
  null
  
)

export default component.exports